import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import { withRouter } from 'react-router-dom';
import { GoogleMap } from '@react-google-maps/api';
import MarkerClusterer from '@google/markerclusterer';
import ProfileStatistic from 'components/Dashboard/OtsAgents/ProfileStatistic';
import { getLocations } from 'utilities/common';

const MAP_CONTAINER_STYLE = { width: '100%', height: '100%' };

class AmbassadorMap extends PureComponent {
  constructor(props) {
    super(props);
    this.map = null;
    this.markerClusterer = null;
    this.state = {
      center: {
        lat: getLocations().lat,
        lng: getLocations().lng,
      },
      zoom: 10,
      isFullScreen: false,
    };
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src =
      'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js';
    script.async = true;
    document.body.appendChild(script);

    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
  }

  componentWillUnmount() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ambassadorData !== this.props.ambassadorData || !this.props.ambassadorData.length) {
      this.setClusterOnMap();
    }
  }

  onFullscreenChange = () => {
    this.setState({
      isFullScreen: !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ),
    });
  };

  handleMapLoad = map => {
    this.map = map;
    this.setClusterOnMap();
  };

  setClusterOnMap = () => {
    const { ambassadorData, fetchAddress } = this.props;
    const maps = window.google?.maps;
    const clusterOptions = {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      gridSize: 30,
      zoomOnClick: false,
      maxZoom: 10,
    };

    if (this.map && maps && ambassadorData.length !== 0) {
      const infoWindow = new maps.InfoWindow('');
      const markers = [];

      if (ambassadorData.length === 1 && ambassadorData[0].locationLat && ambassadorData[0].locationLong) {
        this.map.setCenter({
          lat: ambassadorData[0].locationLat,
          lng: ambassadorData[0].locationLong,
        });
      }

      for (let i = 0; i < ambassadorData.length; i += 1) {
        const data = ambassadorData[i];
        if (data.locationLat && data.locationLong) {
          const marker = new maps.Marker({
            position: { lat: data.locationLat, lng: data.locationLong },
            icon: '/marker1.png',
          });
          markers.push(marker);

          maps.event.addListener(marker, 'click', async () => {
            let address = '';
            if (typeof fetchAddress === 'function') {
              try {
                address = await fetchAddress(marker.position.lat(), marker.position.lng());
              } catch (err) {
                console.error(err);
              }
            }

            infoWindow.setContent(`
              <div class="ambassador_tooltip">
                <p>${data.firstName || ''} ${data.lastName || ''} - ${data.eid || ''}</p>
                <p>Última ubicación registrada:</p>
                <p>${address || ''}</p>
              </div>
            `);
            infoWindow.open(this.map, marker);
          });
        }
      }

      if (this.markerClusterer) {
        this.markerClusterer.clearMarkers();
      }
      this.markerClusterer = new MarkerClusterer(this.map, markers, clusterOptions);

      const styles = this.markerClusterer.getStyles();
      for (let i = 0; i < styles.length; i += 1) {
        styles[i].textColor = 'white';
        styles[i].textSize = 18;
      }
    }
  };

  render() {
    const { center, zoom, isFullScreen } = this.state;
    const { mapType, statisticInfo } = this.props;

    return (
      <div className="ambassador_map_layout" style={{ position: 'relative' }}>
        <GoogleMap
          mapContainerStyle={MAP_CONTAINER_STYLE}
          center={center}
          zoom={zoom}
          onLoad={this.handleMapLoad}
        />
        {isFullScreen && mapType === 'multi_ambassador' && (
          <ProfileStatistic statisticInfo={statisticInfo} />
        )}
      </div>
    );
  }
}

AmbassadorMap.propTypes = {
  ambassadorData: PropTypes.array,
  statisticInfo: PropTypes.array,
  mapType: PropTypes.string,
  fetchAddress: PropTypes.func,
};

AmbassadorMap.defaultProps = {
  ambassadorData: [],
  statisticInfo: [],
  mapType: 'single_ambassador',
  fetchAddress: async () => '',
};

export default compose(withRouter)(AmbassadorMap);
